import { shallowEqual, useSelector } from 'react-redux';

import { RECOMMENDATION_ENGINES } from '@/domains/productDiscovery/Recommendation/constants';
import { useRecommendationSelector } from '@/domains/productDiscovery/Recommendation/hooks/useRecommendationSelector/useRecommendationSelector';

export type UseIsProductComparatorEnabledHook = () => {
  isEnabled: boolean;
};

export const useIsProductComparatorEnabled: UseIsProductComparatorEnabledHook =
  () => {
    const { recommendationConfigSelector: comparatorRecoConfigSelector } =
      useRecommendationSelector(RECOMMENDATION_ENGINES.SIMILARITY_ML_V2); // Same products that ProductComparator_v1 has

    const comparatorRecoConfig = useSelector(
      comparatorRecoConfigSelector,
      shallowEqual,
    );

    return {
      isEnabled: !!comparatorRecoConfig?.modelIds?.length,
    };
  };
